import { render, staticRenderFns } from "./index.vue?vue&type=template&id=585ede30&scoped=true&"
import script from "./createstory.js?vue&type=script&lang=js&"
export * from "./createstory.js?vue&type=script&lang=js&"
import style0 from "./createstory.scss?vue&type=style&index=0&id=585ede30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ede30",
  null
  
)

export default component.exports